<template>
  <div
    v-if="has_perm('view_property') || GET_ACCOUNT_DATA.id == 1"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-tachometer"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Mã"
                    v-model="search.code"
                  />
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Tên Thiết Bị Đo"
                  v-model="search.name"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Loại Thiết Bị Đo"
                  v-model="search.type_name"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchMeterDevice"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("property.title") }}</b>
            </div>
            <select-option-check
              @callbackData="saveCustomizeTable"
              style="margin-top:-40px;"
              :item="columnsProperty"
              class="dropdown-trigger"
              data-icon="eye"
            ></select-option-check>
          </div>
          <div class="box-body">
            <lte-table
              v-if="has_perm('view_property') ||  GET_ACCOUNT_DATA.id == 1"
              :hdBackground="hdBackground"
              :data="gridPropertyDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :actions="
                GET_ACCOUNT_DATA.id == 1 ||
                (has_perm('delete_property'))
                  ? actions
                  : ['common.modify', 'common.printPdf']
              "
              :useFilter="useFilter"
              :boxStyle="boxStyle"
            ></lte-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
// import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';

export default {
  name: "Property",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridPropertyDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "common.code", isHidden: true },
        { text: "property.name", isHidden: true },
        { text: "property.type_name", isHidden: true },
        { text: "property.amount", isHidden: true }
      ],
      columnsProperty: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      actions: ["common.modify", "common.delete", "common.printPdf"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      dateOptions: {
        format: "DD-MM-YYYY hh:mm a"
      },
      paginatorItem: {
        commit_function: "GET_PROPERTY_LIST"
      },
      search: {
        code: "",
        name: "",
        type_name: ""
      },
      isLoading: false
    };
  },
  watch: {
    GET_PROPERTY_DATA: function() {
      this.gridPropertyDataList = [];
      this.GET_PROPERTY_DATA.forEach((property, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = property.code;
        let name = property.name;
        let type_name = property.type_name;
        let id = property.id;
        let amount = property.amount;
        let data = {
          "common.nonumber": nonumber,
          "common.code": code,
          "property.name": name,
          "property.type_name": type_name,
          "property.amount": amount,
          id: id
        };
        this.gridPropertyDataList.push(data);
      });

      return this.gridPropertyDataList;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsProperty.data_list = this.gridColumns;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_PROPERTY_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSearchMeterDevice: function() {
      const data = {
        params: {
          page: 1,
          code: this.search.code,
          name: this.search.name,
          type_name: this.search.type_name
        }
      };
      this.isLoading = true;
      this.GET_PROPERTY_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    saveCustomizeTable: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "propertylist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    addNew: function() {
      this.$router.push({
        name: "PropertyAdd",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "PropertyAdd",
          params: {
            id: recordData.id
          }
        });
      } else if (actionsType == LTEActionTypeEnum.PRINT) {
        let routeData = this.$router.resolve({
          name: "PropertyPdf",
          params: {
            id: recordData.id
          }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    onConfirm: function() {
      this.isModalVisible = false;

      this.DELETE_PROPERTY(this.originalRecordData).then(
        function() {
          let currentPage = this.PAGINATION.page;
          let totalPage = this.PAGINATOR.length;
          let page =
            currentPage >= totalPage && this.gridCustomerDataList.length == 1
              ? totalPage - 1
              : currentPage;
          const data = {
            params: {
              page: page
            }
          };
          this.GET_PROPERTY_LIST(data);
          this.SUCCESS_TOAST();
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_PROPERTY_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_PROPERTY_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.GET_PROPERTY_LIST(data);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_PROPERTY_LIST",
      "DELETE_PROPERTY",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG"
    ])
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_PROPERTY_LIST(data);
    this.columnsProperty.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "propertylist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
  },

  components: {
    // "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "select-option-check": SelectOptionCheck
  }
};
</script>
s



// WEBPACK FOOTER //
// src/views/Property/PropertyList.vue